<template>
    <div class="MultiSliderQuestion">
        <title-section
            :title="title"
            :text="description">
        </title-section>

        <div class="MultiSliderQuestion__sliders">
            <div
                v-for="n in this.length"
                :key="n"
            >
                <p class="h3">{{ measure }} {{ n }}</p>
                <vue-slider
                    class="Slider"
                    :tooltip-style="{ 
                        'border-color': '#34A34E',
                        'background-color': '#34A34E',
                        'font-weight': 'bold',
                        'letter-spacing': '0.25px',
                        'height': '24px',
                        'line-height': '23px',
                        'padding-left': '10px',
                        'padding-right': '10px',
                    }"
                    :tooltip="'always'" v-model="values[n-1]"
                    v-bind="slider(`${measure} ${n}`)"
                    @change="change()">
                </vue-slider>
            </div>
        </div>

        <div>
            <next-button v-bind="{
                next
            }" ></next-button>
        </div>
    </div>
</template>

<script>
    import TitleSection from '../TitleSection.vue';
    import VueSlider from 'vue-slider-component';
    import 'vue-slider-component/theme/default.css';
    import NextButton from '../buttons/NextButton.vue';
    import * as track from '@/utilities/tracking';

    export default {
        name: 'MultiSliderQuestion',
        components: {
            TitleSection,
            NextButton,
            VueSlider
        },
        created: function() {
            this.$store.commit('update', { name: 'previous', value: this.previous });
        },
        mounted() {
            track.step(this.$store.state.step);
        },
        props: {
            title: String,
            measure: String,
            description: String,
            min: Number,
            type: String,
            start: Number,
            max: Number,
            tick: Number,
            length: Number,
            step: Number,
            value: Array,
            name: String,
            next: [String, Number],
            previous: [String, Number]
        },
        computed: {
            ariaLabel() {
                return `${this.title}, ${this.description}`;
            },
            values() {
                var i;
                var array = this.value
                if (array.length < this.length) {
                    for (i = array.length; i < this.length; i++) {
                        array.push(this.min);
                    }
                } else if (array.length > this.length) {
                    for (i = array.length; i > this.length; i--) {
                        array.pop();
                    }
                }
                this.$store.commit('update', {name: this.name, value: array});
                return array;
            },
            slider() {
                return (sliderLabel) => { 
                    return {
                        dotSize: 25,
                        width: 'auto',
                        height: 4,
                        contained: false,
                        direction: 'ltr',
                        data: null,
                        min: this.min,
                        max: this.max,
                        interval: this.step,
                        disabled: false,
                        clickable: true,
                        duration: 0.5,
                        adsorb: false,
                        lazy: true,
                        tooltip: 'focus',
                        tooltipPlacement: 'top',
                        useKeyboard: true,
                        enableCross: true,
                        fixed: false,
                        minRange: void 0,
                        maxRange: void 0,
                        order: true,
                        marks: val => {
                            if (val % this.tick === 0) {
                                return {label: `${val}`};
                            } else {
                                return false;
                            }
                        },
                        dotOptions: {
                            focusStyle: { border: '3px solid #FCC52E', boxShadow: 'none' }
                        },
                        dotAttrs: {
                            'aria-label': `${this.ariaLabel.replace('<br>', '')}, ${sliderLabel}`
                        },
                        process: true,
                        railStyle: void 0,
                        dotStyle: { backgroundColor: '#34A34E' },
                        processStyle: { backgroundColor: '#34A34E'  },
                        tooltipStyle: { backgroundColor: '#34A34E'  },
                        stepStyle: void 0,
                        stepActiveStyle: void 0,
                        labelStyle: {
                            marginTop: '1em',
                            lineHeight: '1.5em',
                        },
                        labelActiveStyle: void 0,
                    }
                }
            }
        },
        methods: {
            change: function() {
                this.$store.commit('update', {name: this.name, value: this.values});
            },
            nextQuestion: function() {
                if (this.next == "results") {
                    this.$router.push(this.next);
                } else {
                    this.$store.commit('update', { name: 'previous', value: this.key });
                    this.$store.commit('update', { name: 'step', value: this.next });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .MultiSliderQuestion {
        margin-bottom: 60px;
    }

    .MultiSliderQuestion__sliders {
        margin-top: 40px;
        margin-bottom: 70px;

        @media screen and (min-width: 767px) {
            margin-top: 30px;
        }
    }
</style>
